import { Card, CardBody, Col, Container, Label, Row } from "reactstrap";
import React from "react";
import LoggedInUserContent from "../../../pages/EventPreOrder/organisersEventPage/loggedInUserContent";
import ParticlesAuth from "../../../pages/AuthenticationInner/ParticlesAuth";
import LoadingSpinner from "../../Common/Spinner";
import LoginToManageYourEvent from "../../../pages/EventPreOrder/organisersEventPage/loginToManageYourEvent";
import OrganisersEventPage from "../../../pages/EventPreOrder/organisersEventPage";
import { isEmpty } from "lodash";

export function TabStepCBranding({
  customerDetails,
  setCustomerDetails,
  handleRemoveEmailRow,
  handleAddEmailRow,
  handleRemovePhoneRow,
  handleAddPhoneRow,
  toggleVerticalTab,
  activeVerticalTab,
}) {
  const handleFileConvertToBase64 = (file) => {
    if (!file || !file.type.match("image.*")) return;
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => {
      setCustomerDetails((prev) => ({ ...prev, LogoUrl: reader.result }));
    };
  };
  return (
    <>
      <div>
        <h5>Branding Preview</h5>
      </div>

      <div>
        <Row className="g-3">
          <Col lg={9}>
            <div
              style={{
                background: customerDetails?.PortalCssColourPageBackground,

                paddingTop: "50px",
                paddingBottom: "50px",
              }}
            >
              <div
                className={
                  "d-flex flex-column align-items-center justify-content-center"
                }
                style={{
                  background: customerDetails?.PortalCssColourDivBackground,
                }}
              >
                <div>
                  <div
                    className={"d-flex flex-row justify-content-center py-2"}
                  >
                    <img
                      src={customerDetails?.LogoUrl}
                      alt="logo"
                      style={{ width: "200px" }}
                    />
                  </div>
                </div>
                <div>
                  <h3
                    className={"pb-2  text-center"}
                    style={{
                      color: customerDetails?.PortalCssColourDivHeading,
                    }}
                  >
                    Event Registration
                  </h3>
                  <div
                    className={"text-center"}
                    style={{
                      color: customerDetails?.PortalCssColourDivText,
                    }}
                  >
                    <span>
                      Event if you have any questions please contact your
                      organiser.
                    </span>
                  </div>
                  <div className={"pt-2  m-2"}>
                    <div className={"d-flex  mb-2 w-100"}>
                      <div className={"d-flex flex-column   mb-2 w-100"}>
                        <input
                          className={
                            "form-control send-user-invitation-email-input mt-2 "
                          }
                          type="text"
                          placeholder="First Name"
                          value={""}
                        />
                        <input
                          className={
                            "form-control send-user-invitation-email-input mt-2"
                          }
                          type="text"
                          placeholder="Last Name"
                          value={""}
                        />
                        <input
                          className={
                            "form-control send-user-invitation-email-input mt-2"
                          }
                          type="text"
                          placeholder="Email"
                          value={""}
                        />
                        <input
                          className={
                            "form-control send-user-invitation-email-input mt-2"
                          }
                          type="text"
                          placeholder="Telephone Number"
                          value={""}
                        />

                        <div
                          className={
                            "d-flex flex-row w-100 mt-2 justify-content-between"
                          }
                        >
                          <button
                            style={{
                              color: customerDetails?.PortalCssButtonTextColour,
                              background:
                                customerDetails?.PortalCssButtonBackgroundColour,
                              border: "none",
                              //hover colours different
                            }}
                            className={
                              "btn btn-success m-0 p-2 send-user-invitation-email-button "
                            }
                            onClick={() => {
                              //
                            }}
                          >
                            Sign Up for Event
                          </button>
                        </div>
                      </div>
                      <div></div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </Col>
          <Col lg={3} className={"border-start"}>
            <div className={"p-2"}>
              <div>
                <h6 className={"fw-bold "}>Options</h6>
              </div>
              <div>
                <Label>Page Background</Label>
                <input
                  type="color"
                  className="form-control"
                  value={customerDetails?.PortalCssColourPageBackground}
                  onChange={(e) => {
                    setCustomerDetails({
                      ...customerDetails,
                      PortalCssColourPageBackground: e.target.value,
                    });
                  }}
                />
              </div>
              <div className={"mt-2"}>
                <Label>Section Background</Label>
                <input
                  type="color"
                  className="form-control"
                  value={customerDetails?.PortalCssColourDivBackground}
                  onChange={(e) => {
                    setCustomerDetails({
                      ...customerDetails,
                      PortalCssColourDivBackground: e.target.value,
                    });
                  }}
                />
              </div>
              <div className={"mt-2"}>
                <Label>Heading</Label>
                <input
                  type="color"
                  className="form-control"
                  value={customerDetails?.PortalCssColourDivHeading}
                  onChange={(e) => {
                    setCustomerDetails({
                      ...customerDetails,
                      PortalCssColourDivHeading: e.target.value,
                    });
                  }}
                />
              </div>
              {/*<div>PortalCssFontFamilyDivHeading</div>*/}
              <div className={"mt-2"}>
                <Label>Text</Label>
                <input
                  type="color"
                  className="form-control"
                  value={customerDetails?.PortalCssColourDivText}
                  onChange={(e) => {
                    setCustomerDetails({
                      ...customerDetails,
                      PortalCssColourDivText: e.target.value,
                    });
                  }}
                />
              </div>
              {/*<div>PortalCssFontFamilyDivTextPortalCssFontFamilyDivText</div>*/}
              <div className={"mt-2"}>
                <Label>Button Text</Label>
                <input
                  type="color"
                  className="form-control"
                  value={customerDetails?.PortalCssButtonTextColour}
                  onChange={(e) => {
                    setCustomerDetails({
                      ...customerDetails,
                      PortalCssButtonTextColour: e.target.value,
                    });
                  }}
                />
              </div>
              <div className={"mt-2"}>
                <Label>Button Background</Label>
                <input
                  type="color"
                  className="form-control"
                  value={customerDetails?.PortalCssButtonBackgroundColour}
                  onChange={(e) => {
                    setCustomerDetails({
                      ...customerDetails,
                      PortalCssButtonBackgroundColour: e.target.value,
                    });
                  }}
                />
              </div>
              {/*<div>PortalCssEmailHeadingTextColour</div>*/}
              <div className={"mt-2"}>
                <Label>Upload Logo</Label>
                <input
                  type="file"
                  accept="image/*"
                  className="form-control"
                  onChange={(e) => {
                    if (e.target.files[0]) handleFileConvertToBase64(e.target.files[0]);
                  }}
                />
                {customerDetails?.LogoUrl && (
                  <div className="mt-1 d-flex align-items-center gap-2">
                    <img src={customerDetails.LogoUrl} alt="logo preview" style={{ height: 32, objectFit: "contain" }} />
                    <span
                      className="btn btn-soft-danger btn-sm"
                      onClick={() => setCustomerDetails((prev) => ({ ...prev, LogoUrl: "" }))}
                    >
                      Remove
                    </span>
                  </div>
                )}
              </div>
            </div>
          </Col>
        </Row>

        <hr className="my-4 text-muted" />
      </div>

      <div className="d-flex align-items-start gap-3 mt-4">
        <button
          type="button"
          className="btn btn-light btn-label previestab"
          onClick={() => {
            toggleVerticalTab(activeVerticalTab - 1);
          }}
        >
          <i className="ri-arrow-left-line label-icon align-middle fs-16 me-2"></i>{" "}
          Contact Information
        </button>
        <button
          type="button"
          className="btn btn-success btn-label right ms-auto nexttab"
          onClick={() => {
            toggleVerticalTab(activeVerticalTab + 1);
          }}
        >
          <i className="ri-arrow-right-line label-icon align-middle fs-16 ms-2"></i>
          Finish
        </button>
      </div>
    </>
  );
}
